import {
	reThemesOgulConstants
}from './constants'
import api from './api'
import {
	defAction
}from "../../../helpers/defaultAction"

export const themesOgulActions = {
	getAllThemesOgul,
	getThemeOgulByName,
	createThemeOgul,
	deleteThemeOgul,
	updateThemeOgul,
	restoreThemeOgul,
	clearThemeOgul
}

function getAllThemesOgul(values){
	const dispatchObj = {
		constants : reThemesOgulConstants.GetReThemeOgul,
		service   : {
			func: api.getAllThemesOgul,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function getThemeOgulByName(values){
	const dispatchObj = {
		constants : reThemesOgulConstants.GetReThemeOgul,
		service   : {
			func   : api.getThemeOgulByName,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function clearThemeOgul(){
	return (dispatch) => dispatch({
		type: reThemesOgulConstants.GetReThemeOgul.CLEAR
	})
}

function createThemeOgul(values){
	const dispatchObj = {
		constants : reThemesOgulConstants.CreateThemesOgul,
		service   : {
			func   : api.createThemeOgul,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function deleteThemeOgul(values){
	const dispatchObj = {
		constants : reThemesOgulConstants.DeleteThemesOgul,
		service   : {
			func   : api.deleteThemeOgul,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function restoreThemeOgul(values){
	const dispatchObj = {
		constants : reThemesOgulConstants.RestoreThemesOgul,
		service   : {
			func   : api.restoreThemeOgul,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function updateThemeOgul(values){
	const dispatchObj = {
		constants : reThemesOgulConstants.UpdateThemesOgul,
		service   : {
			func   : api.updateThemeOgul,
			params : values
		}
	}
	return defAction(dispatchObj)
}
